import React from "react";
import { connect } from "react-redux";

import Tooltip from "antd/es/tooltip";
import camelCase from "lodash-es/camelCase";
import { useIntl } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/enum";
import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";
import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";

import formatDateTypeRange from "@app/component/input/dateRangeSelect/utils/formatDateTypeRange";
import HeatMapLayerData from "@app/scene/map/store/layers/heatMap/HeatMapLayerData";
import { getActiveActivityTypes } from "@app/store/activity";
import { getFunnels } from "@app/store/deal";
import { RootState } from "@app/store/rootReducer";

import ActivityList from "./ActivityList";
import styles from "./FilteringInfo.module.scss";
import FunnelList from "./FunnelList";

interface Props {
  activityTypes: ActivityType[];
  data: HeatMapLayerData;
  funnels: Funnel[];
}

const FilteringInfo: React.FC<Props> = ({ activityTypes, data, funnels }) => {
  const intl = useIntl();

  const formattedDateRange = formatDateTypeRange(intl, data.dateRangeType, data.dateRange, true);

  return (
    <div className={styles.container}>
      <Tooltip title={formattedDateRange}>
        <div className={styles.info}>
          {intl.formatMessage(
            {
              id: "map.layer.heatMap.legend.type",
              defaultMessage:
                "{type, select, crmActivities {Count of Activity} deals {Revenue} other {unknown}} • {dateRange}",
              description: "All time date range label in HeatMap legend on Map page",
            },
            {
              dateRange: formattedDateRange,
              type: camelCase(data.type),
            }
          )}
        </div>
      </Tooltip>
      <div className={styles.info}>
        {data.type === EntityType.ACTIVITY ? (
          <ActivityList
            activityTypes={activityTypes}
            visibleActivityTypeIds={data.activityTypeIds}
          />
        ) : (
          <FunnelList funnels={funnels} visibleFunnelIds={data.funnelIds} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  activityTypes: getActiveActivityTypes(state),
  funnels: getFunnels(state),
});

export default connect(mapStateToProps)(FilteringInfo);
